/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Html_StarterInputs */

const cs_builder_html_starter = /** @type {(inputs: Builder_Html_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukázkový dokument — nahraďte vlastním obsahem.`)
};

const en_builder_html_starter = /** @type {(inputs: Builder_Html_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample document — replace with your content.`)
};

/**
* | output |
* | --- |
* | "Sample document — replace with your content." |
*
* @param {Builder_Html_StarterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_html_starter = /** @type {((inputs?: Builder_Html_StarterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Html_StarterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_html_starter(inputs)
	return cs_builder_html_starter(inputs)
});